// import {
//   ISupportChatParams,
//   ISupportChatSDK,
// } from '@wix/support-chat-widget-server';
import { __awaiter, __generator } from "tslib";
var SUPPORT_CHAT_SCRIPT_URL = 'https://apps.wix.com/support-chat-widget/script.js';
var w = window;
var supportChatWidgetWrapper = /** @class */ (function () {
    function supportChatWidgetWrapper() {
        var _this = this;
        this.init = function (supportChatParams, isDevMode) {
            if (isDevMode === void 0) { isDevMode = false; }
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!this._sdk) return [3 /*break*/, 2];
                            return [4 /*yield*/, this._loadScript(supportChatParams.overrideScriptUrl || SUPPORT_CHAT_SCRIPT_URL)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [4 /*yield*/, this._sdk._init(supportChatParams, isDevMode)];
                        case 3:
                            _a.sent();
                            return [2 /*return*/, this._sdk];
                    }
                });
            });
        };
        this._loadScript = function (scriptUrl) {
            return new Promise(function (resolve, reject) {
                // Create script element and set attributes
                var script = w.document.createElement('script');
                script.type = 'text/javascript';
                script.async = true;
                script.src = scriptUrl;
                script.crossOrigin = 'anonymous';
                // Append the script to the DOM
                var el = w.document.getElementsByTagName('script')[0];
                el.parentNode.insertBefore(script, el);
                script.onload = script.onreadystatechange = function () {
                    var rs = this.readyState;
                    if (rs && rs !== 'complete' && rs !== 'loaded') {
                        return;
                    }
                    resolve(script);
                };
                // Catch any errors while loading the script
                script.addEventListener('error', function (event) {
                    console.error('error loading chat widget', event);
                    reject(new Error(scriptUrl + " failed to load - " + event.message));
                });
            });
        };
    }
    Object.defineProperty(supportChatWidgetWrapper.prototype, "_sdk", {
        get: function () {
            return w.WixSupportChatSDK;
        },
        enumerable: false,
        configurable: true
    });
    return supportChatWidgetWrapper;
}());
export default new supportChatWidgetWrapper();
//# sourceMappingURL=index.js.map